import axios from 'axios'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 20000,
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    'X-Requested-With': 'XMLHttpRequest',
    'Cache-Control': 'no-store, no-cache, must-revalidate'
  }, // request timeout
  // 跨域是否带Token
  // withCredentials: true,
  // 响应的数据格式 json / blob /document /arraybuffer / text / stream
  responseType: 'json',
  // XSRF 设置
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN'
})

// request interceptor
service.interceptors.request.use(
  config => {
    // const tokenStr = getToken()
    const tokenStr = '123456789'
    // if (store.getters.token) {
    //   config.headers.authorization = `${tokenStr}`
    // }
    config.headers.authorization = `${tokenStr}`
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error && error.response) {
        switch (error.response.status) {
          case 400:
            error.message = '错误请求'
            break
          case 401:
            error.message = '未授权，请重新登录'
            break
          case 403:
            error.message = '拒绝访问'
            break
          case 404:
            error.message = '请求错误,未找到该资源'
            break
          case 405:
            error.message = '请求方法未允许'
            break
          case 408:
            error.message = '请求超时'
            break
          case 500:
            error.message = '服务器端出错'
            alert('网络不通畅，请重试！')
            break
          case 501:
            error.message = '网络未实现'
            alert('网络不通畅，请重试！')
            break
          case 502:
            error.message = '网络错误'
            alert('网络不通畅，请重试！')
            break
          case 503:
            error.message = '服务不可用'
            alert('网络不通畅，请重试！')
            break
          case 504:
            error.message = '网络超时'
            alert('网络不通畅，请重试！')
            break
          case 505:
            error.message = 'http版本不支持该请求'
            alert('网络不通畅，请重试！')
            break
          default:
            error.message = `连接错误${error.response.status}`
            alert(error.response.status)
        }
      } else {
        error.message = '连接到服务器失败'
      }
      return Promise.reject(error)
  }
)

export default service
